import {
  AdminAppConfigApi,
  AdminAuthApi,
  AdminAwardsApi,
  AdminCategoryApi,
  AdminCompetitionApi,
  AdminContentPagesApi,
  AdminDashboardApi,
  AdminGoodiesApi,
  AdminNotificationApi,
  AdminReferralApi,
  AdminSubmissionsApi,
  AuthUsersApi,
  Configuration,
  ContentPagesApi,
  PublicCompetitionsApi,
  PublicSubmissionsApi,
  SocialCommentsApi,
  SocialLikesApi,
  SocialReportsApi,
  SocialVotesApi,
  UploadsApi,
  UsersManagementApi,
} from "@talenzap/sdk";

import axiosClient from "@/services/axiosClient";

import { env } from "../../env";

const BASE_URL = env.NEXT_PUBLIC_API_BASE_URL;

const clientSdkConfig = new Configuration({
  basePath: BASE_URL,
});

export const authApi = new AdminAuthApi(clientSdkConfig, undefined, axiosClient);

export const userAuthApi = new AuthUsersApi(clientSdkConfig, undefined, axiosClient);

export const categoriesApi = new AdminCategoryApi(clientSdkConfig, undefined, axiosClient);

export const competitionApi = new AdminCompetitionApi(clientSdkConfig, undefined, axiosClient);

export const submissionApi = new AdminSubmissionsApi(clientSdkConfig, undefined, axiosClient);

export const notificationApi = new AdminNotificationApi(clientSdkConfig, undefined, axiosClient);

export const adminReferralApi = new AdminReferralApi(clientSdkConfig, undefined, axiosClient);

export const uploadApi = new UploadsApi(clientSdkConfig, undefined, axiosClient);

export const usersApi = new UsersManagementApi(clientSdkConfig, undefined, axiosClient);

export const prizesApi = new AdminGoodiesApi(clientSdkConfig, undefined, axiosClient);
export const awardsApi = new AdminAwardsApi(clientSdkConfig, undefined, axiosClient);
export const adminDashboardApi = new AdminDashboardApi(clientSdkConfig, undefined, axiosClient);

export const socialLikesApi = new SocialLikesApi(clientSdkConfig, undefined, axiosClient);

export const socialCommentsApi = new SocialCommentsApi(clientSdkConfig, undefined, axiosClient);

export const socialReportsApi = new SocialReportsApi(clientSdkConfig, undefined, axiosClient);

export const socialVotesApi = new SocialVotesApi(clientSdkConfig, undefined, axiosClient);

export const contentPagesApi = new ContentPagesApi(clientSdkConfig, undefined, axiosClient);

export const adminContentPagesApi = new AdminContentPagesApi(
  clientSdkConfig,
  undefined,
  axiosClient,
);

export const adminAppConfigApi = new AdminAppConfigApi(clientSdkConfig, undefined, axiosClient);

// Public API Services
export const competitionPublicApi = new PublicCompetitionsApi(
  clientSdkConfig,
  undefined,
  axiosClient,
);

export const submissionPublicApi = new PublicSubmissionsApi(
  clientSdkConfig,
  undefined,
  axiosClient,
);

export default clientSdkConfig;
